import { Columns, Column, Skeleton } from "@aviary";
import { ContentWrapper } from "@shared/components/ProductCard";
import { Size } from "@shared/types/sizes";

import * as cardStyles from "./ProductDetailsCard.styles";

const SkeletonProductDetailsCard = () => (
  <ContentWrapper type={Size.LARGE}>
    <Columns css={cardStyles.skeletonColumns}>
      <Column css={cardStyles.detailsColumn} columnWidth={7}>
        <Skeleton type="typography" typographySize="h1" margin="bottom" width={8} />
        <Skeleton type="typography" typographySize="h5" margin="bottom" />
        <Skeleton type="typography" typographySize="h5" margin="bottom" />
        <Skeleton type="typography" typographySize="h5" margin="bottom" />
        <div css={cardStyles.skeletonButtonWrapper}>
          <Skeleton type="button" />
          <Skeleton type="button" />
        </div>
      </Column>
      <Column css={cardStyles.imageColumnSkeleton} columnWidth={5}>
        <Skeleton type="image" isFullwidth css={cardStyles.imageSkeleton} />
      </Column>
    </Columns>
    <div css={cardStyles.skeletonButtonWrapper}>
      <Skeleton type="button" />
      <Skeleton type="button" />
      <Skeleton type="button" />
    </div>
    <Skeleton type="typography" typographySize="h5" isFullwidth margin="topLarge" />
  </ContentWrapper>
);

export { SkeletonProductDetailsCard };
